module.exports = __webpack_public_path__ + "static/media/Languages.59c3e8a6.svg";